import { render, staticRenderFns } from "./GreetingPrompt.vue?vue&type=template&id=56e31c12&lang=pug&"
import script from "./GreetingPrompt.vue?vue&type=script&lang=js&"
export * from "./GreetingPrompt.vue?vue&type=script&lang=js&"
import style0 from "./GreetingPrompt.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports